/**
 * @generated SignedSource<<cc0cfcc094b9034490fd8d8399566b5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type CourseCardSummaryQuery$variables = {
  courseId: string;
  date: string;
  facilityId: string;
  groupSize?: number | null | undefined;
  holeCount?: HoleCount | null | undefined;
  timeGte?: string | null | undefined;
  timeLte?: string | null | undefined;
};
export type CourseCardSummaryQuery$data = {
  readonly facility: {
    readonly agendas?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agendaSummary: {
            readonly firstTime: string | null | undefined;
            readonly lastTime: string | null | undefined;
            readonly maxPrice: number;
            readonly minPrice: number;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CourseCardSummaryQuery = {
  response: CourseCardSummaryQuery$data;
  variables: CourseCardSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "courseId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "facilityId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupSize"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "holeCount"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeGte"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeLte"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "facilityId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "dateGte",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "dateLte",
    "variableName": "date"
  }
],
v9 = {
  "alias": null,
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "courseIds.0",
          "variableName": "courseId"
        }
      ],
      "kind": "ListValue",
      "name": "courseIds"
    },
    {
      "kind": "Variable",
      "name": "holeCount",
      "variableName": "holeCount"
    },
    {
      "kind": "Variable",
      "name": "playerCount",
      "variableName": "groupSize"
    },
    {
      "kind": "Variable",
      "name": "timeGte",
      "variableName": "timeGte"
    },
    {
      "kind": "Variable",
      "name": "timeLte",
      "variableName": "timeLte"
    }
  ],
  "concreteType": "AgendaSummary",
  "kind": "LinkedField",
  "name": "agendaSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxPrice",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CourseCardSummaryQuery",
    "selections": [
      {
        "alias": "facility",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "CourseCardSummaryQuery",
    "selections": [
      {
        "alias": "facility",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "AgendaConnection",
                "kind": "LinkedField",
                "name": "agendas",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgendaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agenda",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Facility",
            "abstractKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "706054fb6ba3d18aa6ce44637c6319ef",
    "id": null,
    "metadata": {},
    "name": "CourseCardSummaryQuery",
    "operationKind": "query",
    "text": "query CourseCardSummaryQuery(\n  $facilityId: ID!\n  $courseId: ID!\n  $date: Date!\n  $timeLte: Time\n  $timeGte: Time\n  $groupSize: Int\n  $holeCount: HoleCount\n) {\n  facility: node(id: $facilityId) {\n    __typename\n    ... on Facility {\n      agendas(dateGte: $date, dateLte: $date) {\n        edges {\n          node {\n            agendaSummary(courseIds: [$courseId], timeGte: $timeGte, timeLte: $timeLte, playerCount: $groupSize, holeCount: $holeCount) {\n              firstTime\n              lastTime\n              minPrice\n              maxPrice\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb3985c0d75d9d75504662c08118c9da";

export default node;
